import { createSlice } from "@reduxjs/toolkit";
import {
  showTimekeepingOnline,
  getTimekeepingApproval,
  showTimekeepingOnlineData,
} from "../actions";

const initialState = {
  timekeepingOnline: [],
  timekeepingOnlineApproval: [],
  timekeepingOnlineData: [],
};

const timekeepingSlice = createSlice({
  name: "timekeeping",
  initialState,
  reducers: {},
  extraReducers: {
    [showTimekeepingOnline.fulfilled]: (state, action) => {
      state.timekeepingOnline = action.payload || [];
    },
    [getTimekeepingApproval.fulfilled]: (state, action) => {
      state.timekeepingOnlineApproval = action.payload || [];
    },
    [showTimekeepingOnlineData.fulfilled]: (state, action) => {
      state.timekeepingOnlineData = action.payload || [];
    },
  },
});

export const responseTimekeeping = (state) => state.timekeeping;

export default timekeepingSlice.reducer;
